import { FC } from 'react';
import classNames from 'classnames';

import { i18n as I18n } from '../../../utils/i18n';

const classes = classNames(
  'booking-slot__btn',
  'booking-slot__btn--unavailable',
  'booking-slot__btn--no-times'
);

interface Props {
  label?: string;
}

const ClosedSlot: FC<Props> = ({ label = I18n.t('shared.closed') }) => {
  return (
    <div className="booking-slots">
      <button type="button" className={classes} disabled>
        {label}
      </button>
    </div>
  );
};

export default ClosedSlot;
